import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import MyPartyResponse from "./responses/apiResponses";
import { handleAxiosError, ApiResponse } from "./responses/AxiosResponseHandler";
import { PartyModel } from "../types";
import { parseMyPartyResponse } from "./parseResponse/parseMyPartiesResponse";

class AlsoGoingOutGroupsApi {

    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async getAlsoGoingOutGroups(cityId: string | null): Promise<ApiResponse<PartyModel[]> | undefined> {

        try {

            const authenticationResponse = this.authClient.getAuthenticationResponse();

            let cityIdForFilter = cityId;
            if (cityIdForFilter === null && authenticationResponse) {
                cityIdForFilter = authenticationResponse.cityId;
            }

            if (!cityIdForFilter) {
                console.error("City ID is missing in the authentication response.");
                return {
                    data: [],
                    statusCode: 404,
                    errorMessage: 'City ID not found',
                }
            }

            const response = await axios.get(
                `${this.authClient.getApiRoot()}/Cities/${cityIdForFilter}/alsoGoingOutGroups`,
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse?.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: "",
                data: (response.data as MyPartyResponse[]).map(parseMyPartyResponse),
            };

        } catch (error) {
            const errorResponse = handleAxiosError<PartyModel[]>(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage,
                data: errorResponse.data
            }
        }
    }
}

export default AlsoGoingOutGroupsApi;
